import { render, staticRenderFns } from "./LoraParserRowMobile.vue?vue&type=template&id=4fcfd654&scoped=true&"
import script from "./LoraParserRowMobile.vue?vue&type=script&lang=ts&"
export * from "./LoraParserRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./LoraParserRowMobile.vue?vue&type=style&index=0&id=4fcfd654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcfd654",
  null
  
)

export default component.exports